import { Controller } from '@hotwired/stimulus';

/**
 * Editmode-only preview toggle for the Gillamoos hero.
 *
 * On the live site the gillamoos-countdown controller decides which state to
 * show (ticking countdown vs. the "fair is running" block). In Pimcore editmode
 * that controller is intentionally not attached, so editors would never see the
 * running block. This toggle flips the `.is-running` class on the mint block so
 * both states can be previewed — and the running copy edited — from the editor.
 */
export default class extends Controller {
    static targets = ['button'];

    toggle() {
        const running = this.element.classList.toggle('is-running');

        if (this.hasButtonTarget) {
            this.buttonTarget.textContent = running
                ? 'Vorschau: Volksfest läuft'
                : 'Vorschau: Countdown';
        }
    }
}
